import React, { useEffect } from 'react';
import { BooleanInput, type BooleanInputProps } from 'react-admin';
import { useCompany } from 'hooks/useCompany';
import { useFormContext } from 'react-hook-form';

type LocationSaasInputProps = Pick<BooleanInputProps, 'source' | 'label'> & { companyId?: number };

export function LocationSaasInput(props: LocationSaasInputProps) {
  const { companyId, source, ...rest } = props;
  const { data } = useCompany(companyId);
  const { setValue } = useFormContext();
  const isHidden = !companyId || !data?.[source];

  useEffect(() => {
    if (isHidden) {
      setValue(source, null, { shouldDirty: true });
    }
  }, [isHidden, setValue, source]);

  if (isHidden) {
    return null;
  }

  return <BooleanInput source={source} {...rest} />;
}
